import { createElement } from "../21946.js";

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var warning_solid_SvgWarningSolid = function SvgWarningSolid(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.567 2.366c1.12-1.803 3.745-1.803 4.866 0l4.37 7.031c1.187 1.909-.186 4.377-2.433 4.377H3.63c-2.248 0-3.62-2.468-2.434-4.377zM8 4.106c.396 0 .716.32.716.716v3.223a.716.716 0 1 1-1.432 0V4.822c0-.395.32-.716.716-.716m-.895 6.616a.895.895 0 1 1 1.79 0 .895.895 0 0 1-1.79 0"
  })));
};
/* export default */ const warning_solid = (warning_solid_SvgWarningSolid);
export default warning_solid;
